import {createFileRoute} from '@tanstack/react-router';

import MedicationRequestCreate from '@/practitioner/views/medicationRequest/MedicationRequestCreate';

export const Route = createFileRoute('/(practitioner)/practitioner/medication-requests/create')({
  component: MedicationRequestCreate
});
